import {green700, orange700, red700} from "assets/jss/main";

export function getScoreLevel(score = null) {
    if (score == null) {
        return null
    }

    const ratio = score / 100;

    if (ratio < 0.40) {
        return 0;
    } else if (ratio < 0.70) {
       return 1;
    }

    return 2;
}

export function getScoreTheme(score = null) {
    if (score == null) {
        return null;
    }

    let scoreTheme;
    let scoreColor;

    const colorLevel = getScoreLevel(score);

    if (colorLevel === 0) {
        scoreTheme  = 'error';
        scoreColor = red700
    } else if (colorLevel === 1) {
        scoreTheme = 'warning';
        scoreColor = orange700
    } else {
        scoreTheme = 'online';
        scoreColor = green700
    }

    return {
        theme: scoreTheme,
        color: scoreColor,
    }
}
